export const getFlaggedReasonText = (formatMessage, flaggedReason) => {
  return formatMessage({
    id: `flag.reason.${flaggedReason}`,
    defaultMessage: flaggedReason,
  });
};

export const setFlaggedReason = (currentState, updateState, eventId, reason) => {
  const reasons = currentState.flaggedReasons ?? {};
  updateState("flaggedReasons", { ...reasons, [eventId]: reason });
};

export const getFlaggedReason = (currentState, eventId) => {
  return currentState.flaggedReasons?.[eventId];
};
